import type { Urteil } from '../data/kaufplan.types'

export const URTEIL_STYLE: Record<Urteil, { label: string; color: string; bg: string; icon: string }> = {
  kaufen:   { label: 'KAUFEN',   color: 'var(--pos)',    bg: 'var(--pos-bg)',  icon: '▲' },
  staffeln: { label: 'STAFFELN', color: 'var(--accent)', bg: 'var(--accent-bg)', icon: '◆' },
  warten:   { label: 'WARTEN',   color: 'var(--warn)',   bg: 'var(--warn-bg)', icon: '■' },
  meiden:   { label: 'MEIDEN',   color: 'var(--neg)',    bg: 'var(--neg-bg)',  icon: '▼' },
}
